import AppointmentDueRessourcesTable from './AppointmentDueRessourcesTable'
export default AppointmentDueRessourcesTable